
import { defineComponent } from "vue";
import SvgIcon from "./SvgIcon.vue";
export default defineComponent({
  components: { SvgIcon },
  name: "CustomSubTitle",
  props: ["icon", "name", "description", "class"],
});
